import * as types from '../actionTypes/CheckoutAnalyticsActionTypes';

export function AnalyticsClickEventReducer(state = [], action) {
    // NOSONAR
    switch (
        action.type // NOSONAR
    ) {
        case types.UPDATE_ANALYTICS_CLICK_EVENT:
            return action.payload;
        default:
            return state;
    }
}

export function DigitalAnalyticsDataReducer(state = [], action) {
    // NOSONAR
    switch (
        action.type // NOSONAR
    ) {
        case types.DIGITAL_ANALYTICS_PAGE_LEVEL_DATA:
            return action.payload;
        default:
            return state;
    }
}

export function AnalyticsClickEventStackReducer(state = [], action) {
    // NOSONAR
    switch (action.type) {
        case types.GET_ANALYTICS_CLICK_EVENT_STACK:
            return state;

        case types.PUT_ANALYTICS_CLICK_EVENT_STACK:
            return [...state, action.payload];

        default:
            return state;
    }
}
